import { basePermissionManagerApi as api } from "../basePermissionManagerApi";
export const addTagTypes = ["Resources"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getResources: build.query<GetResourcesApiResponse, GetResourcesApiArg>({
        query: (queryArg) => ({
          url: `/resources`,
          params: {
            Namespace: queryArg["namespace"],
            ResourceType: queryArg.resourceType,
            ParentId: queryArg.parentId,
            Page: queryArg.page,
            Size: queryArg.size,
          },
        }),
        providesTags: ["Resources"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseGeneratedApi };
export type GetResourcesApiResponse =
  /** status 200 Resources for the namespace + resource type (flat list or hierarchy level). */ ServiceAuthorisationWebModelsResourcesResourcesResponse;
export type GetResourcesApiArg = {
  namespace?: string;
  resourceType?: string;
  parentId?: string;
  page?: number;
  size?: number;
};
export type ServiceAuthorisationWebModelsResourcesResourceItemResponse = {
  resourceId: string | null;
  displayName?: string | null;
  hasChildren?: boolean | null;
};
export type ServiceAuthorisationWebModelsResourcesResourcesResponse = {
  namespace: string | null;
  resourceType: string | null;
  isHierarchy: boolean;
  page?: number | null;
  size?: number | null;
  totalCount?: number | null;
  resources:
    ServiceAuthorisationWebModelsResourcesResourceItemResponse[] | null;
};
export const { useGetResourcesQuery, useLazyGetResourcesQuery } = injectedRtkApi;
